import React from "react";
import { Link } from "react-router-dom";
import { UserPlus, Trophy, ArrowRight } from "lucide-react";

// Free-profile CTA — used on Home, Prospects, Leaderboards, CBR Nation pages.
export function FreeProfileCTA({ className = "" }) {
  return (
    <div data-testid="free-profile-cta" className={`bg-[#0A192F] text-white rounded-sm border-l-4 border-[#E63946] p-6 sm:p-8 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[#E63946]">
            <UserPlus className="w-3.5 h-3.5" /> Free Profile
          </div>
          <h3 className="font-display text-2xl sm:text-3xl uppercase tracking-tight mt-2">Create Your Free CBR Prospects Profile</h3>
          <p className="text-white/70 text-sm mt-2 max-w-xl">
            Build your baseball profile, track your development, receive invitations to CBR Nation opportunities, and showcase your baseball journey.
          </p>
        </div>
        <Link to="/create-profile" data-testid="free-profile-cta-btn"
          className="shrink-0 inline-flex items-center gap-2 px-6 py-3 bg-[#E63946] hover:bg-[#D90429] text-white text-sm font-semibold uppercase tracking-wider rounded-sm transition-colors">
          Create Free Profile <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}

// WWBA interest CTA — kept visually distinct from the free-profile CTA.
export function WWBAInterestCTA({ slug = "wwba-florida", className = "" }) {
  return (
    <div data-testid="wwba-cta" className={`bg-white text-[#0A192F] rounded-sm border border-slate-200 p-6 sm:p-8 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center gap-5 sm:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[#E63946]">
            <Trophy className="w-3.5 h-3.5" /> CBR Nation
          </div>
          <h3 className="font-display text-2xl sm:text-3xl uppercase tracking-tight mt-2">Interested in Representing CBR Nation in Florida?</h3>
          <p className="text-slate-600 text-sm mt-2 max-w-xl">
            Register your interest in the WWBA in Florida. Expression of interest only — our staff will review and follow up.
          </p>
        </div>
        <Link to={`/interest/${slug}`} data-testid="wwba-cta-btn"
          className="shrink-0 inline-flex items-center gap-2 px-6 py-3 bg-[#0A192F] hover:bg-[#1a2a4a] text-white text-sm font-semibold uppercase tracking-wider rounded-sm transition-colors">
          Register Your Interest <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
